<template>
    <div class="p-b-xs-40" v-if="tab && tab.count && tab.data?.length">
        <h4>{{ tab.title }}</h4>

        <ResultList :results="tab.data" :slug="tab.slug"/>
        <div v-if="pagination.numberOfPages > 1">
            <Pagination v-if="showPagination"
                        @pageChanged="$emit('pageChanged')"
            />
            <div v-else class="d-flex  justify-content-center p-t-xs-40">
                <a  href="#" class="button button--ghost" @click.prevent="setActiveSearchable"
                >
                    {{ moreLabel }} {{ tab.title }}
                </a>
            </div>
        </div>
    </div>
</template>
<script>

import {computed} from 'vue';
import ResultList from './ResultList';
import Pagination from '../Pagination/Pagination';
import {useStore} from "vuex";

export default {
    name: "ResultTab",
    components: {
        ResultList,
        Pagination,
    },
    props:{
        tab: Array,
    },
    setup(props, {emit}) {
        const store = useStore()
        const moreLabel = computed(() => store.getters.data.copy.label_read_more)
        const pagination = computed( () => store.getters.data?.pagination);
        const showPagination = computed(() => {
            return store.getters.activeSearchables.length === 1
        })

        const setActiveSearchable = () => {
            store.dispatch('updateSearchable', {
                active: true,
                title: props.tab.title,
                slug: props.tab.slug
            });
            store.dispatch('setPage', 2);
            emit('pageChanged');
        }

        return {
            showPagination,
            moreLabel,
            pagination,
            setActiveSearchable
        }
    }
}
</script>